import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import type { ListItemButtonProps } from '@mui/material';
import { ListItemButton } from '@mui/material';
import type { ElementType } from 'react';

export const StyledScenarioListItem = styled(ListItemButton)<ListItemButtonProps<ElementType>>(({ theme }) => ({
  borderRadius: '2.5rem',
  '&.Mui-selected': {
    backgroundColor: theme.palette.secondary[100]
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary[100]
  },
  '&:hover': {
    backgroundColor: theme.palette.primary[100]
  }
}));

export const StyledScenarioListItemButton = styled(ListItemButton)<ListItemButtonProps<ElementType>>(({ theme }) => ({
  borderRadius: '2.5rem',
  minHeight: '3rem',
  display: 'flex',
  gap: theme.spacing(2),
  '&:hover': {
    backgroundColor: theme.palette.primary[100]
  }
}));

export default makeStyles<Theme>((theme: Theme) => ({
  black: {
    color: 'black'
  },
  colapsedEntered: {
    backgroundColor: theme.palette.grey[50],
    borderRadius: '0.5rem'
  }
}));
